import React from 'react';
import { Link } from 'react-router-dom';
import { HardHat } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-[#1a1a20] mt-24 bg-[#0a0a0c]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#ea9a6f] flex items-center justify-center">
              <HardHat className="w-4 h-4 text-[#0a0a0c]" strokeWidth={2.5} />
            </div>
            <span className="serif text-2xl text-white">Crew<span className="text-[#ea9a6f]">Face</span></span>
          </Link>
          <p className="text-sm text-[#7a7770] mt-4 max-w-xs">Batch professional headshots for the crews who keep the lights on, the roads paved, and the freight moving.</p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-[#7a7770] mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/app" className="text-[#c9c6bf] hover:text-white">Generator</Link></li>
            <li><Link to="/team" className="text-[#c9c6bf] hover:text-white">Admin dashboard</Link></li>
            <li><Link to="/pricing" className="text-[#c9c6bf] hover:text-white">Pricing</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-[#7a7770] mb-3">Compare</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/compare" className="text-[#c9c6bf] hover:text-white">All comparisons</Link></li>
            <li><Link to="/compare/headshotpro" className="text-[#c9c6bf] hover:text-white">vs HeadshotPro</Link></li>
            <li><Link to="/compare/aragon-ai" className="text-[#c9c6bf] hover:text-white">vs Aragon AI</Link></li>
            <li><Link to="/compare/betterpic" className="text-[#c9c6bf] hover:text-white">vs BetterPic</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wider text-[#7a7770] mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="text-[#c9c6bf] hover:text-white">About</a></li>
            <li><a href="#" className="text-[#c9c6bf] hover:text-white">Contact sales</a></li>
            <li><a href="#" className="text-[#c9c6bf] hover:text-white">Security & Trust</a></li>
            <li><a href="#" className="text-[#c9c6bf] hover:text-white">Privacy</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1a1a20] py-6 px-5 md:px-8 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-xs text-[#7a7770]">© 2026 CrewFace, Inc. · Built for field crews.</div>
        <div className="text-xs text-[#7a7770]">SOC 2 Type II · GDPR-ready · Not a substitute for legal or HR compliance advice.</div>
      </div>
    </footer>
  );
}
